import Separator from "@/components/Misc/Separator";
import MoneyBack from "@/components/Misc/MoneyBack";
import { useTemplateStore } from "@/zustand/templateStore";
import s from "@/components/Misc/Separator.module.scss";
import styles from "@/components/Benefits/BenefitsList.module.scss";
import cn from "@/utils/classNames.js";

const BenefitsList = () => {
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);
  const { isMobile } = useTemplateStore();

  return (
    <>
      {!isMobile && <MoneyBack />}
      <Separator
        mainClass={cn(s.separator, s.separator__benefits, isEnhancedContrast && s.enhancedContrast)}
        text={window.post_template.checkout_v6_benefits.tr_benefits_section_title}
        dataTestid="benefits-title"
      />
      {window.post_template.checkout_v6_benefits.checkout_v6_benefits_repeater &&
        window.post_template.checkout_v6_benefits.checkout_v6_benefits_repeater.map((benefit, index) => (
          <div className={styles.benefits__item} key={index}>
            {benefit.tr_checkout_v6_benefits_repeater_icon && (
              <img
                width="32"
                height="32"
                src={benefit.tr_checkout_v6_benefits_repeater_icon}
                alt={benefit.tr_checkout_v6_benefits_repeater_title}
              />
            )}
            <div>
              <div
                data-testid="benefits-item-title"
                className={cn(styles["benefits__item--title"], isEnhancedContrast && styles.enhancedContrast)}
              >
                {benefit.tr_checkout_v6_benefits_repeater_title}
              </div>
              <div
                data-testid="benefits-item-text"
                className={cn(styles["benefits__item--text"], isEnhancedContrast && styles.enhancedContrast)}
              >
                {benefit.tr_checkout_v6_benefits_repeater_text}
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default BenefitsList;
